import { FunctionComponent } from 'react';

import EditStateTextAreaWrapper from './edit-state-text-area-wrapper';
import EditStateWrapper from './edit-state-wrapper';
import randomString from '@/utils/random-string';
import { ChildrenProps, TEditStateTextAreaWrapperProps } from './edit-state-wrapper.types';

type TEditStateTextAreaProps = {
  id?: string;
  Label?: FunctionComponent<ChildrenProps> | string;
  disabled?: boolean;
} & TEditStateTextAreaWrapperProps;

const EditStateTextArea = ({
  id: propsId,
  textAreaProps,
  Label,
  maxRowsBlurred = 2,
  maxRowsFocused = 4,
  disabled,
  ...rest
}: TEditStateTextAreaProps) => {
  const { id: textAreaId, ...restOfTextAreaProps } = textAreaProps || {};
  const id = propsId || textAreaId || randomString(5);

  return (
    <EditStateWrapper
      disabled={disabled}
      focusSelectorOnOpen={`#${id}`}
      focusSelectorOnHeaderClick={`#${id}`}
      Label={Label}
    >
      <EditStateTextAreaWrapper
        maxRowsFocused={maxRowsFocused}
        maxRowsBlurred={maxRowsBlurred}
        textAreaProps={{
          id,
          ...restOfTextAreaProps,
        }}
        {...rest}
      />
    </EditStateWrapper>
  );
};

export default EditStateTextArea;
